import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control, Fold, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

export function HandlerSubForm() {
  const { t } = useTranslation();
  const { register, formState: { errors } } = useFormContext();
  return (
    <Fold isOpen title={t('lunaStreamsStreams:form.event_handler.title')}>
      <SettingsItemWrapper title={t('lunaStreamsStreams:form.event_handler.origin.label')}>
        <Control.Input
          errors={errors}
          {...register('event_handler.origin', {
            required: validate.required(),
          })}
        />
      </SettingsItemWrapper>
      <SettingsItemWrapper title={t('lunaStreamsStreams:form.event_handler.api_version.label')}>
        <Control.Input
          errors={errors}
          {...register('event_handler.api_version', {
            required: validate.required(),
            min: validate.gte(0),
            validate: validate.integer(),
          })}
        />
      </SettingsItemWrapper>
      <SettingsItemWrapper
        data-tooltip-content={t('lunaStreamsStreams:form.event_handler.bestshot_handler.handler_id.tooltip')}
        // FIXME: Для SettingItemWrapper нужен пропс для стилизации модального окна, через
        // commonStylesProps не получается долезть
        modalContent={(
          <div className={st.ModalContent}>
            {t('lunaStreamsStreams:form.event_handler.bestshot_handler.handler_id.tooltip')}
          </div>
        )}
        title={t('lunaStreamsStreams:form.event_handler.bestshot_handler.handler_id.label')}
      >
        <Control.Input
          errors={errors}
          {...register('event_handler.bestshot_handler.handler_id', {
            validate: validate.uuid(),
            required: validate.required(),
          })}
        />
      </SettingsItemWrapper>
      <SettingsItemWrapper title={t('lunaStreamsStreams:form.event_handler.frame_store.label')}>
        <Control.Input {...register('event_handler.frame_store')} />
      </SettingsItemWrapper>
      <SettingsItemWrapper
        data-tooltip-content={t('lunaStreamsStreams:form.event_handler.authorization.tooltip')}
        title={t('lunaStreamsStreams:form.event_handler.authorization.label')}
      >
        <Control.Input {...register('event_handler.authorization.token')} />
      </SettingsItemWrapper>
    </Fold>
  );
}
